import { render } from "./UpdateLog.vue?vue&type=template&id=719588fd&scoped=true"
import script from "./UpdateLog.vue?vue&type=script&lang=js"
export * from "./UpdateLog.vue?vue&type=script&lang=js"

import "./UpdateLog.vue?vue&type=style&index=0&id=719588fd&scoped=true&lang=css"

import exportComponent from "/Users/zwl/Desktop/work/DEV/wms-phone/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-719588fd"]])

export default __exports__